export const LotSizingSizingMethod = {
  STANDARD: 'STANDARD',
  PERSONALISED: 'PERSONALISED',
} as const;

export type LotSizingSizingMethod =
  (typeof LotSizingSizingMethod)[keyof typeof LotSizingSizingMethod];
